var exports = {
  "K": "x112a1f60--05c840--icon",
};

module.exports = exports;
